module.exports = __webpack_public_path__ + "img/screen-contacts.dd32ddd9.png";